export const  GET_TUTOR_GROUP_SESSION_REQUEST='tutorGroupSessionReducer/GET_TUTOR_GROUP_SESSION_REQUEST';
export const  GET_TUTOR_GROUP_SESSION_SUCCESS='tutorGroupSessionReducer/GET_TUTOR_GROUP_SESSION_SUCCESS';
export const  GET_TUTOR_GROUP_SESSION_FAILED='tutorGroupSessionReducer/GET_TUTOR_GROUP_SESSION_FAILED';